import React from 'react'
import { PropTypes } from 'prop-types';
import TotalWorkHoursReport from './TotalWorkHoursReport';
import WorkHourSummaryReport from './WorkHourSummaryReport';
import ProductivityReport from './ProductivityReport';
import UserDetailsReport from './UserDetailsReport';
import EventDetailsReport from './EventDetailsReport';
import ArrivalAndDepartureReport from './ArrivalAndDepartureReport';
import DeviceReport from './DeviceReport';

const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`reports-${index}`}
            aria-labelledby={`reports-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div className='mt-3'>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const ReportsTabs = (props) => {
    const { tabValue, onBack, setLoading, handleFilter, dataFilter, page, pageSize, getTabName, resetTableData, profile, shift, isAdmin, totalPages } = props

    return (
        <div className='reports-tab'>
            <CustomTabPanel value={tabValue} index={0}>
                <TotalWorkHoursReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} shift={shift} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={1}>
                <WorkHourSummaryReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={2}>
                <ProductivityReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={3}>
                <UserDetailsReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={4}>
                <EventDetailsReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={5}>
                <ArrivalAndDepartureReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
            <CustomTabPanel value={tabValue} index={6}>
                <DeviceReport onBack={onBack} setLoading={setLoading} handleFilter={handleFilter} dataFilter={dataFilter} page={page} pageSize={pageSize} getTabName={getTabName} resetTableData={resetTableData} profile={profile} isAdmin={isAdmin} totalPages={totalPages} />
            </CustomTabPanel>
        </div>
    )
}

export default ReportsTabs
